export class cronExpressionModel {
  scheduleType: number = 1;
  date: Date = new Date();
  time: Date= new Date();
  dayOfWeek: Array<number> = [0];
  monthSelectedOption: string = 'Specific Day of Month';
  selectedMonthday: Array<string> =  ['1'];
  expression: string = '';
  isRunNow: boolean = true;
  startDate: Date | null = null; // Allow both Date and null
  endDate: Date | null = null;   // Allow both Date and null
  second: number | null = null;
  minute: number | null = null;
  hour: number | null = null;
  everySelectedOption: number | null = null;
}

